// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Components__SelectSwitchFieldController from "./components/select_switch_field_controller"
application.register("components--select-switch-field", Components__SelectSwitchFieldController)

import Components__ToggleSubmitController from "./components/toggle_submit_controller"
application.register("components--toggle-submit", Components__ToggleSubmitController)

import DatagridController from "./datagrid_controller"
application.register("datagrid", DatagridController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DialogOpenerController from "./dialog_opener_controller"
application.register("dialog-opener", DialogOpenerController)

import ExpensesController from "./expenses_controller"
application.register("expenses", ExpensesController)

import G7AccessHubsController from "./g7_access_hubs_controller"
application.register("g7-access-hubs", G7AccessHubsController)

import G7CommandCodesFormController from "./g7_command_codes_form_controller"
application.register("g7-command-codes-form", G7CommandCodesFormController)

import G7Spaces__AmountToggleController from "./g7_spaces/amount_toggle_controller"
application.register("g7-spaces--amount-toggle", G7Spaces__AmountToggleController)

import G7Spaces__BatchEditController from "./g7_spaces/batch_edit_controller"
application.register("g7-spaces--batch-edit", G7Spaces__BatchEditController)

import GoogleMapsController from "./google_maps_controller"
application.register("google-maps", GoogleMapsController)

import HistoryController from "./history_controller"
application.register("history", HistoryController)

import LaborsController from "./labors_controller"
application.register("labors", LaborsController)

import Locations__LockersController from "./locations/lockers_controller"
application.register("locations--lockers", Locations__LockersController)

import LogBatchErrorsController from "./log_batch_errors_controller"
application.register("log-batch-errors", LogBatchErrorsController)

import MaterialsController from "./materials_controller"
application.register("materials", MaterialsController)

import Owners__Locations__LockerCodesController from "./owners/locations/locker_codes_controller"
application.register("owners--locations--locker-codes", Owners__Locations__LockerCodesController)

import Owners__Locations__LockerSearchController from "./owners/locations/locker_search_controller"
application.register("owners--locations--locker-search", Owners__Locations__LockerSearchController)

import Owners__Locations__UsageReportController from "./owners/locations/usage_report_controller"
application.register("owners--locations--usage-report", Owners__Locations__UsageReportController)

import PartsController from "./parts_controller"
application.register("parts", PartsController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import ProblemReports__LookupPersonResultsController from "./problem_reports/lookup_person_results_controller"
application.register("problem-reports--lookup-person-results", ProblemReports__LookupPersonResultsController)

import ProblemReports__SetCategoriesController from "./problem_reports/set_categories_controller"
application.register("problem-reports--set-categories", ProblemReports__SetCategoriesController)

import ProblemReports__SetPriorityController from "./problem_reports/set_priority_controller"
application.register("problem-reports--set-priority", ProblemReports__SetPriorityController)

import ProblemReports__SetStateController from "./problem_reports/set_state_controller"
application.register("problem-reports--set-state", ProblemReports__SetStateController)

import ServiceVisits__FormController from "./service_visits/form_controller"
application.register("service-visits--form", ServiceVisits__FormController)

import ServiceVisits__WorkOrdersFormController from "./service_visits/work_orders_form_controller"
application.register("service-visits--work-orders-form", ServiceVisits__WorkOrdersFormController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TripsController from "./trips_controller"
application.register("trips", TripsController)
